import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is AR & VR development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>AR and VR development involves creating immersive virtual experiences that blend
                                        the real world with computer-generated elements. AR (augmented reality) involves
                                        overlaying digital information on top of the real world, while VR (virtual
                                        reality) involves creating fully immersive digital environments. AR and VR can
                                        be used for countless purposes, including entertainment, education, training,
                                        and marketing.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What AR and VR development services does TekRevol offer?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol offers various AR and VR development services, including designing and
                                        creating virtual environments, developing custom avatars and characters,
                                        integrating real-time data and analytics, and creating interactive experiences
                                        and games. We work with clients to understand their vision and goals for the AR
                                        and VR experience and use our expertise in virtual reality technology to bring
                                        their ideas to life.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;